/* 
 * Lightcase
 * 
 * Author: Michael Kohler <michael.kohler@somedia.ch>
 */

// Requires
require('jquery');
var mustache = require('mustache');
var langData = {
    de: require('./de.lang'),
    fr: require('./fr.lang'),
    it: require('./it.lang'),
    rm: require('./rm.lang'),
    en: require('./en.lang')
};

// Modul construct
var somModul = {
	
	/* 
	* Current language
	* 
	* @var string Current language iso code
	*/
	currentLang: null,


		
	/* 
	* Set language
	* 
	* @param string lang 
	* @return void
	*/
	setLang: function(lang) {
		somModul.currentLang = lang;
	},
	
	/* 
	* Auto detect language
	* 
	* @return void
	*/
	autoDetectLang: function() {
		
		// Get lang from html tag
		var lang = document.documentElement.lang;
		if(lang.length == 2) {
			somModul.currentLang = lang;
		} else {
			somModul.currentLang = 'de';
		}
	},

	/*
	 * Extend language data
	 *
	 * @param additionalData Data object
	 * @return void
	 */
	extendLangData: function(additionalData) {
		$.extend(true, langData, additionalData);
	},
	
	/* 
	* Get translation
	* 
	* @param string key 
	* @param object params 
	* @return string
	*/
	get: function(key, params) {
		
		// Autodetect language if needed
		if(somModul.currentLang === null) {
			somModul.autoDetectLang();
		}
		
		if(key.length != 0) {
			
			// Create lang key
			key = somModul.currentLang + '.' + key;
			var keyPath = key.split('.').reverse();
			var currentData =  langData;
			
			// Loop through language data
			while(keyPath.length > 0) {
				
				var currentPath = keyPath.pop();
				currentData = currentData[currentPath];
				
				if(typeof currentData == 'string') {
					
					// Use mustache to replace variable
					if(typeof params == 'object') {
						currentData = mustache.render(currentData, params);
					} 
					return currentData;
				}
				
				// No label available
				if(typeof currentData != 'object' || keyPath.length == 0) {
					return 'No translation for key "' + key + '" found';
				}
			}
		}
	}
};

// Return modul construct - commonJS syntax
module.exports = somModul;



/** WEBPACK FOOTER **
 ** ./src/lang/translator.js
 **/